// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__oDPOX","list":"BalanceDue_list__2d_dk","listRow":"BalanceDue_listRow__nhDRC","total":"BalanceDue_total__3y3WR"};